import {useEffect, useRef, useState} from "react";
import swal from "sweetalert";
import axios from "axios";
import {toast} from "react-toastify";
import checkForm, {
  check_value_sal, checkDuplicate, dateValidate, emailValidate, isNumberKey, mobileValidate,
} from "./FormValidation";
import RLookUp from "./RLookUp";
import Loader from "../Loader";
// import swal from 'sweetalert';
import Mh1PersianDatePicker from "./Mh1PersianDatePicker";

import "./Form.scss";
import ReactToPrint, {PrintContextConsumer} from "react-to-print";

import ComponentToPrintBarcodeInEditSection from "./ComponentToPrintBarcodeInEditSection";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import numeric from "../../utils/NumericFunction";
import str from "../../utils/StringFunctions";
import {customstyledate} from "./customstyledateForm";
import {
  needToUploadFiles,
  addDateTimeEtcToFormDom,
  addUploadFunctionality,
  dNoneToExceptionFields,
  makeEmptyIfNoneUploadFile,
  addEditor,
} from "./FormFunction";
import _axios from "../../httpService";

export default function Form(props) {
  let {id, primaryKey, factorId, price} = props;
  const navigateTo = useNavigate();
  const myLocation = useLocation();
  let urlToSendRequest = localStorage.getItem("apiUrl");

  let tempId = useParams()["id"];

  const [afterSubmitRedirect, setAfterSubmitRedirect] = useState({
    url: "", data: {},
  });

  const [showBarcode, setShowBarcode] = useState(false);
  const [data, setData] = useState();
  const [next, setNext] = useState(false);
  const [isItFromEdit, setIsItFromEdit] = useState(undefined);
  const formDOM = useRef(null);
  useEffect(() => {
    // اینجا باید این مقدار ور خالی کنم. این مقدار برای آرلوکاپ استفاده میشه برای جا به جایی داده بین فیلد های آرلوکاپ
    sessionStorage.removeItem("conditionObjectData");
  }, []);

  useEffect(() => {
    // this work now if user Clicked Edit In treeChart
    // debugger
    if (myLocation.state) {
      if (myLocation.state.id || myLocation.state.primaryKey) {
        if (myLocation.state.id) {
          id = myLocation.state.id;
        }

        if (myLocation.state.primaryKey) {
          try {
            const temp = myLocation.state.primaryKey;

            primaryKey = temp + "";
            // myLocation.state.from && setAfterSubmitRedirect(myLocation.state.from)
            setAfterSubmitRedirect({...myLocation.state.from});
          } catch (error) {
            console.error(error);
          }
        }
      }
    } else if (!id) {
      if (!id) {
        id = tempId;
        // urlToSendRequest
        window.location.hostname === "localhost" ? (urlToSendRequest = "http://localhost/Git/Delsa/Frm") : (urlToSendRequest = "/Frm");
      }
    } else {
    }

    setData();
    const paramsOpt = factorId ? {id: "304-s", state: "insert", factorId: factorId, price: price} :
      primaryKey ? {id: id, state: "edit", pkValue: primaryKey,} :
        {id: id, state: "insert",};

    axios({
      method: "GET",
      url: `${urlToSendRequest}/get-form-2/`,
      params: paramsOpt,
      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setData(response.data[0]);
      setNext(response.data[0].nextBtn === "1" && true);
      setIsItFromEdit(!!primaryKey);
      // delete Request fire Two Times... So i copy that here
      if (formDOM.current) {
        if (formDOM.current.querySelectorAll(".delete-btn")) {
          let deleteBtnOnEditForm = formDOM.current.querySelectorAll(".delete-btn");
          if (deleteBtnOnEditForm.length > 0) {
            deleteBtnOnEditForm.forEach(addDeleteFunctionToEachBtn);
          }
        }
      }
    });
  }, [id, primaryKey]);

  // const [lookup, setLookup] = useState();

  //wanna use this state if need to Upload File or Filesss
  let [selectedFileToUpload, setSelectedFileToUpload] = useState([]);

  //on change Function forEach input Box
  function OnChangeAddToStateFunction1(inputBox, index) {
    inputBox.onchange = function (event) {
      event.preventDefault();
      let suffix = "." + event.target.files[0].name.split(".").at(-1);
      let newName = "";
      newName = Math.floor(new Date().getTime() / 1000) + "" + Math.floor(Math.random() * 10) + suffix;
      console.log(newName);

      let file = event.target.files[0];
      let blob = file.slice(0, file.size, file.type);
      let newFile = new File([blob], newName, {type: file.type});

      // every input box Must import One object in selectedFileToUpload State
      let newRow = {name: inputBox.name, selectedFile: newFile};
      const tempArray = [];

      if (selectedFileToUpload.length > 0) {
        let letMePush = true;
        // selectedFileToUpload.map((v) => {
        //     if (v.name === inputBox.name) {
        //         tempArray.push({"name": v.name, selectedFile: newFile});
        //         letMePush = false;
        //     } else {
        //         tempArray.push(v)
        //     }
        // });
        for (let i = 0; i < selectedFileToUpload.length; i++) {
          if (selectedFileToUpload[i].name === inputBox.name) {
            tempArray.push({
              name: selectedFileToUpload[i].name, selectedFile: newFile,
            });
            letMePush = false;
          } else {
            tempArray.push(selectedFileToUpload[i]);
          }
        }
        if (letMePush) {
          tempArray.push(newRow);
        }
      } else {
        tempArray.push(newRow);
      }

      console.log(tempArray);
      setSelectedFileToUpload(tempArray);
    };
  }

  function OnChangeAddToStateFunction(inputBox, index) {
    inputBox.onchange = function (event) {
      event.preventDefault();
      const file = event.target.files[0];
      const suffix = "." + file.name.split(".").pop();
      const newName = `${Math.floor(new Date().getTime() / 1000)}${Math.floor(Math.random() * 10)}${suffix}`;

      const newFile = new File([file], newName, {type: file.type});

      const newRow = {name: inputBox.name, selectedFile: newFile};
      const tempArray = selectedFileToUpload.map((item) => item.name === inputBox.name ? newRow : item);
      debugger;
      if (!tempArray.some((item) => item.name === inputBox.name)) {
        tempArray.push(newRow);
      }

      selectedFileToUpload = [...tempArray];
      console.log(selectedFileToUpload);
      setSelectedFileToUpload(tempArray);
    };
  }

  function addDeleteFunctionToEachBtn(btn, index) {
    btn.addEventListener("click", function (event) {
      event.preventDefault();

      swal("آیا از حذف این فایل اطمینان دارید؟", "", {
        buttons: {
          cancel: "لغو ", ok: "حذف فایل",
        }, icon: "info",
      }).then((value) => {
        switch (value) {
          case "ok":
            axios({
              method: "delete", url: `${urlToSendRequest}/upload/`, params: {
                field: btn.getAttribute("data-name"), pkValue: primaryKey,
              }, headers: {
                Authorization: `Bearer ${localStorage.getItem("token")}`,
              },
            }).then((response) => {
              if (response.data.status) {
                toast.success(response.data.message);
                //  اینجا باید اگه اون استیت فایل های آپلودی  پر بود. یه دونه شو حذف کنم
                if (selectedFileToUpload.length > 0) {
                  let temp = selectedFileToUpload.filter((v) => v.name !== btn.name);
                  setSelectedFileToUpload(temp);
                }
                const temp = btn.getAttribute("data-name");
                const tempIn = "[data-download-name=" + temp + "]";
                // let btnDataAttribiute =  formDOM.current.querySelector('[data-name="`${btnDataAttribiute}`"]');
                // formDOM.current.querySelector('[data-download-name="na_18"]')
                // اینجا هنوز یکم کار دارم 999
                // formDOM.current.querySelector(`[data-download-name="${btn.name}"]`).style.display = "none"
                formDOM.current.querySelector(tempIn).style.display = "none";
              } else {
                toast.info(response.data.message);
              }
            });
            break;
          default:
          //swal("Got away safely!");
        }
      });
    });
  }

  function selectInputsAndMakeEmpty(formDomObject) {
    //debugger
    const formFields = formDomObject.querySelectorAll("input");
    for (let field of formFields) {
      if (field.classList.contains("obj-51") || field.classList.contains("obj-15") || field.classList.contains("obj-37") || field.style.display === "none") {
        // field.value = field.value;
      } else {
        field.value = "";
      }
    }
  }

  function sendFormDataToBack(formDomObject, entityName, getFromBackUrls) {
    setDisable(true);
    //debugger
    let entitiesArray = [];
    let formData = from2Object([formDomObject]);

    // wanna Replce file with file url if there is Somthing to Upload

    if (getFromBackUrls !== undefined) {
      let fileNamesArray = [];
      if (formDomObject.querySelectorAll(".obj-41").length > 0) {
        function wannaTakeIds(v, index) {
          fileNamesArray.push(v.name);
        }

        // console.log(formData);
        let getObj41FileUpload = formDomObject.querySelectorAll(".obj-41");
        getObj41FileUpload.forEach(wannaTakeIds);
        // console.log(getFromBackUrls);
        for (let i = 0; i < fileNamesArray.length; i++) {
          const temp = fileNamesArray[i];
          const tempObject = getFromBackUrls.find((v) => v[temp]);
          if (tempObject) {
            formData[0][temp] = tempObject[temp];
          } else {
            formData[0][temp] = "";
          }
        }
      }
    }

    //  I have a problem back end asked me send  empty string if file not exist So I add this:
    formData = makeEmptyIfNoneUploadFile(formData, formDOM.current);

    let entityData = {
      entity: entityName, data: formData,
    };

    let index = 0;
    entitiesArray[index] = entityData;

    // let HOST = localStorage.getItem("apiUrl");


    const toastId = toast.loading("در حال ارسال فرم...")
    // const formSubmitRequest = axios({

    axios({
      method: "POST", url: `${urlToSendRequest}/frm_submit/`, params: {
        kmo: localStorage.getItem("kmo"),
      }, data: `data=${JSON.stringify({
        entities: entitiesArray,
      })}`, headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    })
      .then((response) => {
        //debugger
        // گاها بک اند برای من یه چیزی میفرسته که 200 نیست
        // من اینجا پیام بک رو نشون میدم و تشکر میکنم و دیگه ادامه نمیدم

        toast.dismiss(toastId)
        if (response.response !== undefined) {
          if (response.response.response?.status === 406) {
            toast.error(response?.response.data.message);
            setDisable(false);
            return;
          }
        }
        if (response.data.status) {
          // در واقع اگه ثبت فرم با موفقیت انجام شد بیا استیت فایل های آپلودی رو خالی کن
          setSelectedFileToUpload([]);
          if (afterSubmitRedirect.url) {
            navigateTo(afterSubmitRedirect.url, {
              state: {data: afterSubmitRedirect.data},
            });
            toast.success("ثبت فرم با موفقیت انجام شد");
            return;
          }
          response.data.barcodeCountUserInput = 1;
          if (response.data.showBarcode) {
            setSubmitResponse(response.data.data);
            setShowBarcode(response.data.showBarcode);
          }
          // if (isItFromEdit === true) {
          selectInputsAndMakeEmpty(formDomObject);
          toast.success("ثبت فرم با موفقیت انجام شد");
        }
        setDisable(false);
      })
      .catch((error) => {
        //
        setDisable(false);
        toast.error("ثبت فرم با مشکل مواجه شد");
        console.error(error.message);
      });
  }

  function formSubmitHandler(formDomObject, entityName, setSubmitResponse, next) {
    //
    console.log(selectedFileToUpload);
    //Remove commas in price
    let numberFieldsClass = formDomObject.querySelectorAll(".obj-25");
    if (numberFieldsClass.length > 0) {
      numberFieldsClass.forEach(plzForeEach);

      function plzForeEach(value, index) {
        formDomObject.querySelector(`#${value.id}`).value = formDomObject
          .querySelector(`#${value.id}`)
          .value.replaceAll(",", "");
      }
    }
    if (id === "869-s") {
      let price = formDOM.current.querySelector('[name="na_466"]').value;
      if (price > remainFactor) {
        price = "";
        toast.error("مبلغ نمیتواند بیش از مبلغ باقی مانده فاکتور باشد");
        return false;
      }
    }

    let getFromBackUrls = [];

    // اگه از ویرایش اومده بود و فایل آپلودی میخواست  الزامی بودنش رو حذف میکنم. تا توی ارسال دوباره اطلاعات گیر نده بده الزامیه
    function removeRequiedPlease(input, index) {
      input.removeAttribute("required");
    }

    if (isItFromEdit === true) {
      if (formDOM.current.querySelectorAll(".obj-41").length > 0) {
        formDOM.current
          .querySelectorAll(".obj-41")
          .forEach(removeRequiedPlease);
      }
    }

    if (checkForm([formDomObject])) {
      // if (true) {
      // in some cases we need to Upload File Or FileSss
      let needToUpload = needToUploadFiles(selectedFileToUpload, formDomObject);

      // functions for Upload Files
      if (needToUpload === true) {
        let isEveryThingOkToSendAllFormToBack = true;
        // اینجا یه آرایه میسازم و همه ی فایل های آپلودی رو میریزم توش که بفرستم بک اند
        // قبلا دونه دونه میفرستادم ولی الان  میخوام گروهی ارسال بشه چون قبلا یکم باگ داشت متد رو عوض کردیم
        const formData = new FormData();
        selectedFileToUpload.forEach((v, index) => {
          formData.append(v.name, v.selectedFile);
        });
        if (isEveryThingOkToSendAllFormToBack === false) {
          toast.info("یک یا چند فایل آپلود نشدند... دوباره تلاش کنید.");
        } else {
          const messageToShowWhenUpload = {
            pending: "در حال بارگزاری فایل...",
            success: "فایل(ها) آپلود شد(ند).",
            error: "آپلود فایل با خطا رو به رو شد دوباره تلاش کنید.",
          };

          const uploadVariableToShowStatus = // کد های قبلی باشه اگه مشکلی پیش اومد برگردونم
            //   axios({
            //   method: "post",
            //   // url: `${urlToSendRequest}/upload/`,
            //   url: `https://saden.varkan.ir/Frm/upload/index2.php`,
            //   data: formData,
            //   headers: {
            //     Authorization: `Bearer ${localStorage.getItem("token")}`,
            //   },
            // })
            // با متد جدید کوتاه تر
            _axios
              .post(`${urlToSendRequest}/upload/`, formData)
              .then((response) => {
                const data = response.data;
                if (data.status) {
                  //console.log(formDomObject);
                  // const toPush = {};
                  // toPush[v.name] = data.message;
                  getFromBackUrls = data.filesAddress;
                  // //
                  sendFormDataToBack(formDomObject, entityName, getFromBackUrls);
                  // بعد از آپلود فایل من این استیت رو خالی میکردم.
                  //اما  اگه سری اول ثبت فرم از طرف بک اند به مشکل میخورد ارور میداد و کلید مربوط به یه آبجگت خالی بود.
                  // اما من اینو از اینجا کامنت میکنم و میگم وقتی که  کلا فرم ثبت شد بیا استیت آپلود رو خالی کن.
                  //setSelectedFileToUpload([]);
                  data.message && (messageToShowWhenUpload.success = data.message);
                } else {
                  isEveryThingOkToSendAllFormToBack = false;
                  toast.error(data.message);
                  data.message && (messageToShowWhenUpload.error = data.message);
                }
              });

          //uploadVariableToShowStatus
          toast.promise(uploadVariableToShowStatus, {
            pending: messageToShowWhenUpload.pending,
            success: messageToShowWhenUpload.success,
            error: messageToShowWhenUpload.error,
          });
        }

        // selectedFileToUpload.map((v) => {
        //   const formData = new FormData();
        //   formData.append(v.name, v.selectedFile);
        //   axios({
        //     method: "post", url: `${urlToSendRequest}/upload/`, data: formData, headers: {
        //       Authorization: `Bearer ${localStorage.getItem("token")}`,
        //     },
        //   }).then((response) => {
        //     response = response.data;
        //     //
        //     if (response.status) {
        //       toast.info("در حال بارگزاری فایل...");
        //       //console.log(formDomObject);
        //       const toPush = {};
        //       toPush[v.name] = response.message;
        //
        //       getFromBackUrls.push(toPush);
        //     } else {
        //       isEveryThingOkToSendAllFormToBack = false;
        //       toast.error(response.message);
        //     }
        //   });
        // });

        // setTimeout(() => {
        //   console.log("sendData Fired");
        //   if (isEveryThingOkToSendAllFormToBack === false) {
        //     toast.info("یک یا چند فایل آپلود نشدند... دوباره تلاش کنید.");
        //     return;
        //   }
        //   axios({
        //     method: "post", url: `${urlToSendRequest}/test/`, data: [], headers: {
        //       Authorization: `Bearer ${localStorage.getItem("token")}`,
        //     },
        //   }).then((response) => {

        //     sendFormDataToBack(formDomObject, entityName, getFromBackUrls);
        //     setSelectedFileToUpload([]);
        //   });
        // }, 1000);
      } else {
        // toast.info("نیاز به آپلود چیزی نیست بریم که اطلاعات فرم رو ارسال کنیم.");
        sendFormDataToBack(formDomObject, entityName);
      }
    } else {
      toast.error(" لطفا موارد ورودی را بررسی کنید.");
    }
  }

  function from2Object(formObjs) {
    let formData = [];

    for (let i = 0; i < formObjs.length; i++) {
      let form = new FormData(formObjs[i]);
      // let form = formObjs.eq(i).serializeArray();
      let datajson = {};
      for (const input of form.entries()) {
        datajson[input[0]] = input[1];
      }
      formData.push(datajson);
    }

    return formData;
  }

  const [remainFactor, setRemainFactor] = useState("");

  useEffect(() => {
    if (data !== undefined) {
      let lookupFields = formDOM.current.querySelectorAll(".obj-51");
      let selectFields = formDOM.current.querySelectorAll("select");
      for (let i of selectFields) {
        var selectedVal = i.getAttribute("value");
        let options = i.querySelectorAll("option");
        for (let option of options) {
          let value = option.value;
          if (value === selectedVal) {
            option.setAttribute("selected", "true");
          } else {
          }
        }
      }

      for (const field of lookupFields) {
        if (field.dataset.disable !== "yes") {
          field.addEventListener("click", () => {
            sessionStorage.setItem("rlookup", JSON.stringify({
              id: field.dataset.rlookupid, variables: field.dataset.variables, fieldName: field.name,
            }));

            setModalIsOpen(true);
          });
        }
      }

      // mrm15
      let obje25s = formDOM.current.querySelectorAll(".obj-25");
      for (const field of obje25s) {
        // console.log(toNumber);
        field.addEventListener("keyup", () => {
          for (let i = 1; i <= field.value.length; i++) {
            field.value = field.value.replace(",", "");
          }
          // if input in Not a number Remove input
          if (isNaN(field.value)) {
            field.value = field.value.replace(/\D/g, "");
          }
          let counter = 0;

          for (let i = 1; i <= field.value.length; i++) {
            if (i % (3 * (counter + 1) + counter) === 0 && field.value.length - i !== 0) {
              let tempVal = field.value;
              field.value = str.addStr(tempVal, field.value.length - i, ",");
              counter++;
              // console.log(field.value);
            }
          }
        });
      }
      //   formDOM.current.querySelector('[name="na_466"]').onclick = function () {
      //     let value = formDOM.current.querySelector('[name="na_454"]').value;
      //     if (value === "") {
      //       toast.error("ابتدا کد فاکتور را انتخاب کنید");
      //     } else {
      //       axios({
      //         method: "get",
      //         url: `${urlToSendRequest}/Formfunctions/`,
      //         params: {
      //           factorId: value,
      //         },
      //         headers: {
      //           Authorization: `Bearer ${localStorage.getItem("token")}`,
      //         },
      //       }).then(
      //         (response) =>
      //           (formDOM.current.querySelector('[name="na_466"]').value =
      //             response.data)
      //       );
      //     }
      //   };

      function setRemainPrice() {
        let value = formDOM.current.querySelector('[name="na_454"]').value;
        formDOM.current
          .querySelector('[name="na_466"]')
          .removeAttribute("readonly");
        if (value === "") {
          toast.error("ابتدا کد فاکتور را انتخاب کنید");
          formDOM.current
            .querySelector('[name="na_466"]')
            .setAttribute("readonly", true);
        } else {
          axios({
            method: "get", url: `${urlToSendRequest}/Formfunctions/`, params: {
              factorId: value,
            }, headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }).then((response) => {
            formDOM.current.querySelector('[name="na_466"]').value = response.data.data;
            setRemainFactor(response.data.data);
          });
        }
      }

      if (id === "869-s") {
        formDOM.current.querySelector('[name="na_466"]').onclick = setRemainPrice;
        let factorId = formDOM.current.querySelector('[name="na_454"]');

        factorId.addEventListener("keydown", function (event) {
          if (event.keyCode === 9) {
            setRemainPrice();
          }
        });
      }


//طبق نمونه آبجکتی که بک داره میده باید چیکار کنیم؟
      // باید  ببینم اول که آقا کدوم فیلد رو میخواد پنهان کنه برم پنهانش کنم.

      for (let x of data.hidden) {
        for (let element of x.dependency) {
          debugger
          if (formDOM?.current) {
            if (formDOM.current
              .querySelector(`#${element.id}`)
              ?.closest(".form-group")) {
              formDOM.current
                .querySelector(`#${element.id}`)
                .closest(".form-group").style.display = "none";
            }

          }
        }
      }
      // حالا که پنهان کردی  همه رو بیا روی آن چنج اون آیدی یه دونه رو استثناعا از اون حالت در بیار و نشون بده
      for (let x of data.hidden) {
        let field = formDOM.current.querySelector(`#${x.id}`);
        let value = field?.value;
        // for (let option of x.dependency) {
        //   formDOM.current
        //     .querySelector(`#${option.id}`)
        //     .closest(".form-group").style.display = "none";
        //   if (value === option.value) {
        //     let input = document.querySelector(`#${option.id}`);
        //     input.closest(".form-group").style.display = "block";
        //     input.setAttribute("required", "");
        //   }
        // }

        field?.addEventListener("change", (e) => {
          debugger
          let value = field?.value;
          x?.dependency?.forEach((option, i) => {
            console.log(option);
            // display none all of them
            formDOM.current
              .querySelector(`#${option.id}`)
              .closest(".form-group").style.display = "none";
          })

          x?.dependency.forEach((option, i) => {
            if (e.target.value === option.value) {
              let input = document.querySelector(`#${option.id}`);
              input.closest(".form-group").style.display = "block";
              input.setAttribute("required", "");
            }
          })

          console.log("================================")

        });
      }

      let uniqueFields = formDOM.current.querySelectorAll("[data-unique=true]");
      for (const field of uniqueFields) {
        field?.addEventListener("blur", (e) => checkDuplicate(field?.dataset?.mj, field?.name, e.target.value, field, field?.name));
      }
      // // این قسمت مربوط به فیلدهای دیت هست که میخایم بجاشون datepicker بذاریم
      // let dateFields=formDOM.current.querySelectorAll(".obj-15");
      // for(let field of dateFields){
      //     return(
      //         <DatePicker
      //         calendar={persian}
      //         className="form-control"
      //         placeholder="تاریخ"
      //         locale={persian_fa}
      //         calendarPosition="bottom-right"
      //         hideOnScroll
      //      />
      //     )
      // }

      let otherFields = formDOM.current.querySelectorAll("[data-type]");
      for (const field of otherFields) {
        switch (field?.dataset.type) {
          case "email":
            field?.addEventListener("blur", () => {
              emailValidate(field);
            });
            break;
          case "mobile":
            field?.addEventListener("blur", () => {
              mobileValidate(field);
            });
            field?.addEventListener("keypress", (e) => {
              isNumberKey(e);
            });
            break;
          case "year":
            field?.addEventListener("blur", () => {
              check_value_sal(field, 1400);
            });
            break;
          case "date":
            field?.addEventListener("blur", () => {
              dateValidate(field);
            });
            field.placeholder = "مانند 1400/01/01";
            break;

          default:
            console.trace(field);
            console.error("unknown input data-type attribute");
            break;
        }
      }
    }
  }, [data]);

  const [modalIsOpen, setModalIsOpen] = useState(false);

  function lookupCallBackDataHandler(data) {
    for (const name in data) {
      formDOM.current[name].value = data[name];
    }
  }

  const [submitResponse, setSubmitResponse] = useState([]);

  // use Ref To ComponentToPrint
  const refToPrintBarcode = useRef();
  const [disable, setDisable] = useState(false);

  // remove exceptionFields from Form
  useEffect(() => {
    data && data?.exceptionFields?.length > 0 && dNoneToExceptionFields(formDOM.current, data.exceptionFields);
  }, [data]);

  useEffect(() => {
    data && setTimeout(() => {
      addDateTimeEtcToFormDom(formDOM.current, isItFromEdit);
      //
      // add event Listeners For Upload Files
      //
      addUploadFunctionality(formDOM.current, OnChangeAddToStateFunction);
      //

      addEditor({formDom: formDOM.current})
      //
    }, 1000);
    //
  }, [data]);

  try {
    return data !== undefined ? (<>
      <style>{customstyledate}</style>

      <h3 className="page-header">{data.title}</h3>
      <div className="form-component">
        {modalIsOpen ? (<RLookUp
          id={JSON.parse(sessionStorage.getItem("rlookup")).id}
          variables={JSON.parse(sessionStorage.getItem("rlookup")).variables}
          callBackDataHandler={lookupCallBackDataHandler}
          modalHandler={[modalIsOpen, setModalIsOpen]}
          fieldName={JSON.parse(sessionStorage.getItem("rlookup")).fieldName}
        />) : null}
        <form
          ref={formDOM}
          className="rasaForm"
          dangerouslySetInnerHTML={{
            __html: data === undefined ? "<div>در حال بارگزاری</div>" : data.form[0],
          }}
        ></form>
        <div className={"w-100 text-center"}>
          <button
            className="btn btnCustom btnSubmit submit-button"
            disabled={disable}
            onClick={() => {
              formSubmitHandler(formDOM.current, data.entity, setSubmitResponse, next);
            }}
          >
            ثبت
          </button>
        </div>
        {showBarcode && (<>
          <div className="barcodeLabelContainer">
            <div className="border-black" style={{}}>
              <div className="barcodeLabel">
                <div
                  className={"border border-dark rounded-3"}
                  style={{margin: " 0 auto", width: "max-content"}}
                >
                  <ComponentToPrintBarcodeInEditSection
                    submitResponse={submitResponse}
                    ref={refToPrintBarcode}
                  />
                </div>
              </div>
            </div>
          </div>

          <br/>
          <div className={"text-center"}>
            {/* here is Section Code To Print */}
            <ReactToPrint content={() => refToPrintBarcode.current}>
              <PrintContextConsumer>
                {({handlePrint}) => (<button
                  disabled={submitResponse === undefined}
                  className="btnCustom btnSubmit"
                  onClick={handlePrint}
                >
                  پرینت بارکد
                </button>)}
              </PrintContextConsumer>
            </ReactToPrint>
            {/* End ::: here is Section Code To Print */}
          </div>
        </>)}
      </div>
    </>) : (<Loader/>);
  } catch (error) {
    return <>{error.toString()}</>
  }
}
